<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<li>
				<span>Estimated survey time</span>
				<span>{{ dataList.bx001 }}</span>
			</li>
			<li>
				<span>Place</span>
				<span>{{ dataList.bx002 }}</span>
			</li>
			<li>
				<span>Other</span>
				<span>{{ dataList.bx003 }}</span>
			</li>
			<li>
				<span>Survey content</span>
				<span>{{ dataList.bx004 }}</span>
			</li>
			<li>
				<span>Company of contact</span>
				<span>{{ dataList.bx005 }}</span>
			</li>

			<li>
				<span>Title of contact</span>
				<span>{{ dataList.bx006 }}</span>
			</li>
			<li>
				<span>kind of insurance case</span>
				<span>{{ dataList.bx007 }}</span>
			</li>
			<li>
				<span>Type of insurance</span>
				<span>{{ dataList.bx008 }}</span>
			</li>
			<li>
				<span>The background</span>
				<span>{{ dataList.bx009 }}</span>
			</li>
			<li>
				<span>Name of insurance case</span>
				<span>{{ dataList.bx010 }}</span>
			</li>
			<li>
				<span>Place of inpect</span>
				<span>{{ dataList.bx011 }}</span>
			</li>
			<li>
				<span>Place of inpect</span>
				<span>{{ dataList.bx012 }}</span>
			</li>
			<li>
				<span>Whether special tool need or not</span>
				<span>{{ dataList.bx013 }}</span>
			</li>
			<li>
				<span>Remarks</span>
				<span>{{ dataList.bx014 }}</span>
			</li>
			<li>
				<span>Site survey records, customer notification, template of adjustment and inspection report, etc</span>
				<div v-if="dataList.bx015">
					<div style="cursor: pointer;color: #fff;margin-top: 10px; " v-for="(item,index) in dataList.bx015.split('|')" @click="open(item)">{{item}}</div>
				</div>


			</li>
			<li>
				<span>Site photoes by insurant</span>
				<div class="imgs" v-if="dataList.bx016">
					<img :src="item" v-for="(item, index) in dataList.bx016.split('|')" />
				</div>
			</li>
			<li>
				<span>Site inspect</span>
				<div class="imgs" v-if="dataList.bx017">
					<img :src="item" v-for="(item, index) in dataList.bx017.split('|')" />
				</div>
			</li>
			<li>
				<span>Date and time of inspect</span>
				<span>{{ dataList.bx018 }}</span>
			</li>
			<li>
				<span>Information from insurant</span>
				<div class="imgs" v-if="dataList.bx019">
					<img :src="item" v-for="(item, index) in dataList.bx019.split('|')" />
				</div>
			</li>
			<li>
				<span>Inspect site</span>
				<span>{{ dataList.bx020 }}</span>
			</li>
			<li>
				<span>Joint inpector</span>
				<span>{{ dataList.bx021 }}</span>
			</li>
			<li>
				<span>List and detail of inspect site</span>
				<span>{{ dataList.bx022 }}</span>
			</li>
			<li>
				<span>Inpection record signed</span>
				<div class="imgs" v-if="dataList.bx023">
					<img :src="item" v-for="(item, index) in dataList.bx023.split('|')" />
				</div>
			</li>
			<li>
				<span>Photos took by inspector</span>
				<div class="imgs" v-if="dataList.bx024">
					<img :src="item" v-for="(item, index) in dataList.bx024.split('|')" />
				</div>
			</li>
			<li>
				<span>Photos for informer</span>
				<div class="imgs" v-if="dataList.bx025">
					<img :src="item" v-for="(item, index) in dataList.bx025.split('|')" />
				</div>
			</li>

			<li>
				<div style="font-size: 24px;line-height: 40px;color: #fff; ">
					Attacments
				</div>
				<span>Preliminary Report</span>
				<div class="imgs" v-if="dataList.bx026">
					<div style="cursor: pointer;color: #fff;margin-top: 10px; " v-for="(item,index) in dataList.bx026.split('|')" @click="open(item)">{{item}}</div>
				</div>
			</li>
			<li>
				<span>Middle feport</span>
				<div class="imgs" v-if="dataList.bx027">
					<div style="cursor: pointer;color: #fff;margin-top: 10px; " v-for="(item,index) in dataList.bx027.split('|')" @click="open(item)">{{item}}</div>
				</div>
			</li>
			<li>
				<span>Final Report</span>
				<div class="imgs" v-if="dataList.bx028">
					<div style="cursor: pointer;color: #fff;margin-top: 10px; " v-for="(item,index) in dataList.bx028.split('|')" @click="open(item)">{{item}}</div>
				</div>
			</li>
			<li>
				<span>Supporting materials of the appraisal report</span>
				<div class="imgs" v-if="dataList.bx029">
					<div style="cursor: pointer;color: #fff;margin-top: 10px; " v-for="(item,index) in dataList.bx029.split('|')" @click="open(item)">{{item}}</div>
				</div>
			</li>
			<li>
				<span>Inspect fee</span>
				<span>{{ dataList.bx030 }}</span>
			</li>







		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'sc',
	components: {
		navTop
	},
	data() {
		return {
			dataList: {}
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulebx();
		}
	},
	methods: {
		open(e){
			window.open(e)
		},
		getSchedulebx() {
			let data = {
				id: this.id
			};
			this.$api.schedulebx(data).then((res) => {
				console.log(res);
				if (res.result == 0) {
					this.dataList = res.data;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			.imgs {
				margin-top: 15px;
				display: flex;
				flex-wrap: wrap;
				img {
					display: block;
					width: 392px;
					height: 292px;
					border-radius: 10px;
					margin-right: 58px;
					margin-bottom: 40px;
				}
				img:nth-child(3n) {
					margin-right: 0;
				}
			}
			.texts {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				span {
					margin-top: 10px;
					font-size: 24px;
					color: #ffffff;
					line-height: 1em;
				}
			}
		}
	}
}
</style>
